import TabInfo from '../../../../common/TabController/TabInfo';
import { CDDVImportTab } from '../../../../../plugin/CDDV/CDDVTab';
import EnterMolDataTab from './EnterMolDataTab';
import CompoundGenerationTab from './CompoundGenerationTab';
import { JobsCompoundsTab } from './JobsCompoundsTab';
import { JobsResultsTab } from './JobsResultsTab';

const tabs = [
    new TabInfo(
        'import_dragpaste_tab',
        'Enter Mol. Data',
        EnterMolDataTab,
    ),
    new TabInfo(
        'import_cddv_tab',
        'CDD Vault',
        CDDVImportTab,
    ),
    new TabInfo(
        'compound_generation_tab',
        'Generate Compounds',
        CompoundGenerationTab,
    ),
    new TabInfo(
        'jobs_compounds_tab',
        'Compound Jobs',
        JobsCompoundsTab,
        {
            ModalPaneProps: {
                style: {
                    maxHeight: '100% !important',
                    maxWidth: 'none',
                },
            },
        }
    ),
    new TabInfo(
        'jobs_compounds_results_tab',
        'Compound Job Results',
        JobsResultsTab,
        {
            ModalPaneProps: {
                style: {
                    maxHeight: '100% !important',
                    maxWidth: 'none',
                },
            },
        }
    ),
];

export default tabs;
